import { useRouter } from "next/router";
import { useAppSelector } from "../../../services/hooks/useReduxHooks";
import { useTranslationI18 } from "../../../services/hooks/useTranslationI18";
import { ContainerStyle, PagesEnum } from "../../../utils/enums";
import { getPageLink } from "../../../utils/help/navigation/navigation";
import { PaperPlaneIcon } from "../../screens/S-Referral/icons";
import { LineArtSvg } from "../Icons/Icons";
import { PLink } from "../PLink";
import styles from "./ReferAFriend.module.scss";

export const ReferAFriend = (props: {
  isSidebar?: boolean;
  scrollable?: boolean;
  containerStyle?: ContainerStyle;
}) => {
  const router = useRouter();
  const { t } = useTranslationI18();
  const {
    isSidebar,
    scrollable,
    containerStyle = ContainerStyle.FLUID,
  } = props;
  const { rewardedPoints } = useAppSelector(
    (state) => state.userInfo.referralCode
  );

  const referAFriend = t("offers:refer-a-friend");
  const points = t("offers:points");
  const referNow = t("offers:refer-now");
  const and = t("common:and");
  const get = t("common:get");

  return (
    <div
      className={`
          ${containerStyle === ContainerStyle.BOXED && styles.container_boxed} 
          ${styles.container}  ${
        isSidebar ? styles.is_side_bar : styles.slider
      } ${scrollable && styles.scrollable}`}
    >
      <PLink link={getPageLink(router, PagesEnum.Referral)} passHref>
        <div className={`${styles.container__bg}`}>
          <span className={styles.line_art_svg}>
            <LineArtSvg />
          </span>

          <span className={styles.paper_plane_svg}>
            <PaperPlaneIcon />
          </span>
        </div>
        <div className={`${styles.referral_body}`} data-testid="refer-a-friend">
          {isSidebar ? (
            <span
              data-testid="go-to-referral-screen"
              className={`${styles.referral_body__title} ${styles.underline}`}
            >
              {referAFriend}
            </span>
          ) : (
            <p className={styles.referral_body__title}>{referAFriend}</p>
          )}
          <p
            className={styles.referral_body__points}
            data-testid="referral-points"
          >
            {and} {get} <span>{rewardedPoints}</span> {points}
          </p>
        </div>
        {!isSidebar && (
          <div
            className={`${styles.referral_body__action} ${
              scrollable && styles.no_margin
            }`}
          >
            <PLink link={getPageLink(router, PagesEnum.Referral)} passHref>
              <span className={styles.btn} data-testid="go-to-referral-screen">
                {referNow}
              </span>
            </PLink>
          </div>
        )}
      </PLink>
    </div>
  );
};
